import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD-rA9SMR8vyp2lke5RaLdzpnCn2PZsblk',
  authDomain: 'cover-letter-7621a.firebaseapp.com',
  projectId: 'cover-letter-7621a',
  storageBucket: 'cover-letter-7621a.firebasestorage.app',
  messagingSenderId: '731105006124',
  appId: '1:731105006124:web:44e2bb34e44b53ac2af789',
  measurementId: 'G-L2MP56G1FE',
};

// Initialize Firebase only if it hasn't been initialized yet
export const app = !getApps().length
  ? initializeApp(firebaseConfig)
  : getApps()[0];

// Export initialized Firestore instance
export const db = getFirestore(app);
